import { render, staticRenderFns } from "./EDOList.vue?vue&type=template&id=5672b4c0&"
import script from "./EDOList.vue?vue&type=script&lang=js&"
export * from "./EDOList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports